import { Base } from '.';
export class Admin extends Base {
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('admins');
    }
}
